import { baseApi } from "./baseApi";

const ROAD_CLOSURE_BASE_URL = "/road-closures";

export const roadClosureApi = baseApi.injectEndpoints({
  tagTypes: ["RoadClosure"],

  endpoints: (builder) => ({
    getRoadClosureMapData: builder.query({
      query: ({ forceRefresh } = {}) => ({
        url: ROAD_CLOSURE_BASE_URL,
        params: forceRefresh ? { forceRefresh: true } : undefined,
      }),
      // Backend already caches the DoR data for 6 hours, so keep the
      // client side response around for a while as well.
      keepUnusedDataFor: 60 * 60,
      providesTags: [{ type: "RoadClosure", id: "LIST" }],
    }),
  }),
});

export const {
  useGetRoadClosureMapDataQuery,
  useLazyGetRoadClosureMapDataQuery,
} = roadClosureApi;
